"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var Section_1 = require("../../utils/Section");
var constants_1 = require("./constants");
exports.default = redux_1.combineReducers(Section_1.getReducers(constants_1.namespace));
//# sourceMappingURL=reducer.js.map